import defineMessages from "../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    title1: {
        id: "intro.solfaname.1.title",
    },
    title3: {
        id: "intro.solfaname.3.title",
    },
    title4: {
        id: "intro.solfaname.4.title",
    },
    description1: {
        id: "intro.chords3.1.description",
    },
    description3: {
        id: "intro.intervals.2.description",
    },
    description4: {
        id: "intro.solfaname.4.description",
    },
});

export default messages;
